import { Box, Button, ButtonBase, Stack, useTheme } from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import { useFormikContext } from 'formik'
import { nanoid } from 'nanoid'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { CgClipboard } from 'react-icons/cg'
import { toast } from 'react-toastify'

export default function ValidatedInputStringGenerator({name}:{name:string}) {

    const theme = useTheme()

    const {setFieldValue, setFieldTouched, errors, touched, values} = useFormikContext<any>()

    const generateRandomString = ()=>{
        setFieldValue(name, nanoid(10))
    }
    
  return (
    <Stack direction="column" spacing={1}>

        <Stack spacing={1} direction="row" sx={{width: "100%", height: "2rem"}}>
            <Box
            sx={styles.fieldBox}
            >
            <input
                type="text"
                className='w-full p-1 h-full bg-white/0 border border-white/10 outline-none'
                disabled
                value={values[name]}
                placeholder="click to generate password"
                onChange={({target})=>{
                    
                }}
            />
            <ButtonBase 
                onBlur={()=>setFieldTouched(name)} 
                onClick={generateRandomString} 
                sx={styles.fieldButton} 
            />
            </Box>
            <CopyToClipboard
                text={values[name]}
                onCopy={()=>{
                    toast(`Copied "${values[name]}" to clipboard`, {
                    position: "top-center",
                    autoClose: 1500,
                    className:"text-center",
                    type: "success",
                    progressClassName: "bg-primary",
                    theme: "dark",
                    hideProgressBar: true,
                    })
                }}
            >
            <Button
                sx={styles.button}
                startIcon={<CgClipboard color={theme.palette.primary.main} />}
                disabled={values[name] === "" ? true : false}
            />
            </CopyToClipboard>
        </Stack>
        {(errors[name] && touched[name]) && 
          (
            <span className="text-left bg-error inline-block w-2 h-2 rounded-full"/>
          )
        }
    </Stack>
  )
}

const styles = {

  fieldBox:{
    flex:4,
    height: "100%", 
    display: "flex", 
    justifyContent: "center", 
    alignItems:"center",
    backgroundColor: "rgba(255,255,255,0)",
    borderRadius: "4px",
    border: "0.3px solid rgba(255,255,255,0)",
    color: grey[500],
    overflow:"hidden",
    position: "relative"
  },
  fieldButton:{
    width: "100%",
    height: "100%", 
    display: "flex", 
    justifyContent: "center", 
    alignItems:"center",
    backgroundColor: "rgba(255,255,255,0.2)",
    borderRadius: "4px",
    border: "0.3px solid rgba(255,255,255,0.2)",
    color: grey[500],
    overflow:"hidden",
    position: "absolute",
    top: 0,
    left: 0
  },
  button:{
    flex: 1,
    height: "100%", 
    display: "flex", 
    justifyContent: "center", 
    alignItems:"center",
    borderRadius: "4px",
    backgroundColor: blue[300],
    '&.MuiButton-root:hover':{
      backgroundColor: blue[400],
    },
    '&.MuiButton-root:disabled':{
      backgroundColor: grey[500],
    }
  }
  
}
